export default {
  statusBadge: {
    draft: '下書き',
    preprocessing: '前処理中',
    awaitingUserMeshing: 'メッシュ待ち',
    awaitingBcReview: '境界条件レビュー待ち',
    awaitingMoboReview: 'レビュー待ち',
    running: '実行中',
    completed: '完了',
    completedWithIssues: '完了（問題あり）',
    failed: '失敗',
    cancelled: 'キャンセル済み',
  },
  dashboard: {
    sortDateCreated: '作成日',
    sortName: '名前',
    moreFilters: 'その他のフィルター',
    typeFilter: 'タイプ',
    tagFilter: 'タグ',
    typeFea: 'FEA',
    typeCfd: 'CFD',
    typeCht: 'CHT',
    tagCfdExt: 'CFD · 外部',
    tagCfdInt: 'CFD · 内部',
    tagCht: 'CHT',
    tagFea: 'FEA',
    tagTet: 'Tet',
    tagHex: 'Hex',
    tagPoly: 'Poly',
    noTypes: 'タイプがありません',
    noTags: 'タグがありません',
    noStatuses: 'ステータスがありません',
    clearFilter: 'フィルターをクリア',
    selectAllStudies: 'すべてのスタディを選択',
    selectStudy: '{{name}} を選択',
    colName: '名前',
    colStatus: 'ステータス',
    colDesignPts: '設計点',
    colProgress: '進捗',
    colCreated: '作成日時',
    colCompleted: '完了日時',
    colUpdated: '更新日時',
    colActions: '操作',
    startNewStudyTitle: '新しいスタディを開始',
    startNewStudySubtitle: 'DOE、サロゲート、または GCI スタディを設定します。',
    newStudy: '新規スタディ',
    studies: 'スタディ',
    studiesCount_one: '{{count}} 件のスタディ',
    studiesCount_other: '{{count}} 件のスタディ',
    searchStudies: 'スタディを検索…',
    selectedCount_one: '{{count}} 件選択中',
    selectedCount_other: '{{count}} 件選択中',
    clear: 'クリア',
    delete: '削除',
    tabAll: 'すべて',
    tabDraft: '下書き',
    tabRunning: '実行中',
    tabCompleted: '完了',
    tabFailed: '失敗',
    emptyTitleNoStudies: 'まだスタディがありません',
    emptyTitleNoMatch: 'フィルターに一致するスタディがありません',
    emptyHintNoStudies: '上の「新規スタディ」をクリックして始めましょう。',
    emptyHintNoMatch: '別のフィルターまたは検索語をお試しください。',
    emptyHintSearchMore:
      '読み込み済みのスタディに一致するものがありません — スクロールしてさらに読み込むか、別の検索をお試しください。',
    loadingStudies: 'スタディを読み込み中…',
    tableEmpty: '利用可能なスタディはまだありません。',
    studyNameLabel: 'スタディ名',
    renameTooltip: '{{name}} — ダブルクリックで名前を変更',
    renameFailed: '失敗',
  },
  deleteDialog: {
    title_one: '{{count}} 件のスタディを削除しますか？',
    title_other: '{{count}} 件のスタディを削除しますか？',
    description_one:
      'このスタディとその結果をスタディ一覧から削除します。この操作は取り消せません。',
    description_other:
      'これら {{count}} 件のスタディとその結果をスタディ一覧から削除します。この操作は取り消せません。',
    cancel: 'キャンセル',
    confirm_one: '{{count}} 件のスタディを削除',
    confirm_other: '{{count}} 件のスタディを削除',
  },
  libraryCard: {
    points: '設計点 {{done}}/{{total}}',
  },
  reviewView: {
    evidence: '根拠',
  },
  userMeshing: {
    geometryFallback: 'ジオメトリ',
    sectionLabel: '設計点 · メッシュ生成',
    allFaceNamed_one: '{{count}} 件の DP の面名が設定されています。',
    allFaceNamed_other: 'すべての {{count}} 件の DP の面名が設定されています。',
    readyWhenFaceNamed_one:
      '{{count}} 件の DP の面名が設定されると準備完了になります。',
    readyWhenFaceNamed_other:
      'すべての {{count}} 件の DP の面名が設定されると準備完了になります。',
    simsQueueHint: '確認後、シミュレーションは自動的にキューに追加されます。',
    completeAndRun: 'メッシュ生成を完了してシミュレーションを実行',
    atAGlance: 'スタディの概要',
    designPoints: '設計点',
    meshTemplate: 'メッシュテンプレート',
    fromStudy: 'スタディから',
    meshesYoursTitle: 'メッシュは永続的にあなたのものです。',
    meshesYoursBody:
      'ここで作成したものはすべて、単体の MeshGen にも表示されます。スタディをキャンセルしても削除されません。',
    cancelStudy: 'スタディをキャンセル…',
    readOnlyTitle: '閲覧のみ',
    readOnlyPastMeshing:
      'このスタディのメッシュ作成は完了しています。メッシュを開いて確認できますが、ここでの変更は実行に反映されません。',
    readOnlyRole:
      'これらのメッシュは閲覧のみ可能です。メッシュ作成を完了できるのはスタディのオーナーまたは編集者だけです。',
  },
  cancelStudy: {
    action: 'スタディをキャンセル…',
    cancelled: 'スタディをキャンセルしました。',
    failed: 'キャンセルに失敗しました。',
  },
  progress: {
    phaseNotUsed: 'このスタディではこのフェーズは使用されません',
    phaseRailAria: '{{label}}：{{total}} 件中 {{done}} 件完了',
    notUsed: '未使用',
    countActive_one: '{{count}} 件実行中',
    countActive_other: '{{count}} 件実行中',
    countFailed_one: '{{count}} 件失敗',
    countFailed_other: '{{count}} 件失敗',
    progress: '進捗',
    designPointsComplete_one: '{{count}} 件の設計点のうち {{completed}} 件完了',
    designPointsComplete_other:
      '{{count}} 件の設計点のうち {{completed}} 件完了',
    failedCount_one: '{{count}} 件失敗',
    failedCount_other: '{{count}} 件失敗',
    meshing: 'メッシュ生成',
    simulating: 'シミュレーション',
    completed: '完了',
    running: '実行中',
    pending: '保留中',
    failed: '失敗',
    cancelled: 'キャンセル済み',
    studyConfiguration: 'スタディ設定',
    noSolverSettings: 'ソルバー設定が構成されていません。',
    sweepVariables: 'スイープ変数',
    someDesignPointsFailed: '一部の設計点が失敗しました。',
    failedDuringMeshing_one: '{{count}} 件がメッシュ生成中に失敗',
    failedDuringMeshing_other: '{{count}} 件がメッシュ生成中に失敗',
    failedDuringPreparation_one: '{{count}} 件が準備中に失敗',
    failedDuringPreparation_other: '{{count}} 件が準備中に失敗',
    failedDuringSimulation_one: '{{count}} 件がシミュレーション中に失敗',
    failedDuringSimulation_other: '{{count}} 件がシミュレーション中に失敗',
    timestampCreated: '作成',
    timestampCompleted: '完了',
    timestampFailed: '失敗',
    timestampCancelled: 'キャンセル',
    timestampStarted: '開始',
    timestampUpdated: '更新',
  },
} as const;
